<template>
  <div class="row">
    <div class="col-lg-7">
      <div class="card shadow-sm border border-gray rounded mb-3 mb-lg-0">
        <div class="card-header bg-white border border-gray border-bottom py-3">
          <div
            class="d-flex flex-wrap align-items-center justify-content-between"
          >
            <div
              class="d-flex align-items-center border border-gray rounded p-2"
            >
              <div class="custom-control custom-switch">
                <input
                  v-model="accion_ruta"
                  type="checkbox"
                  id="accion_ruta"
                  class="custom-control-input"
                />
                <label
                  class="custom-control-label font-weight-bold text-dark"
                  for="accion_ruta"
                >
                  <i class="fas fa-edit mr-1"></i> Editar Ruta
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body p-0 overflow-hidden rounded-0">
          <gmap-map
            class="w-100"
            style="height: 500px"
            id="mapRutaTep"
            :center="viewMap.center"
            :zoom="viewMap.zoom"
            :options="{
              disableDefaultUI: true,
              zoomControl: true,
              mapTypeControl: true,
            }"
          >
            <gmap-marker
              v-if="markers.inicio_ruta"
              :position="markers.inicio_ruta.position"
              :icon="url_docs + '/' + markers.inicio_ruta.icon"
            ></gmap-marker>
            <gmap-marker
              v-if="markers.fin_ruta"
              :position="markers.fin_ruta.position"
              :icon="url_docs + '/' + markers.fin_ruta.icon"
            ></gmap-marker>
            <gmap-polyline
              v-if="markers.ruta.path.length > 0 && !accion_ruta"
              :path="markers.ruta.path"
              :options="{
                strokeColor: '#00529c',
                strokeOpacity: '0.9',
                strokeWeight: 5,
              }"
            ></gmap-polyline>
            <!-- Tramos añadidos en modo edición -->
            <gmap-polyline
              v-for="(tramo, index) in tramosAñadidosConPath"
              :key="'tramo-' + (tramo.id || index)"
              :path="tramo.path"
              :options="{
                strokeColor: tramo.color || '#00529c',
                strokeOpacity: '0.9',
                strokeWeight: 5,
              }"
            ></gmap-polyline>
          </gmap-map>
        </div>
      </div>
    </div>
    <div class="col-lg-5">
      <div class="card shadow-sm border border-gray rounded">
        <div class="card-header bg-white border-0 border-bottom py-3">
          <div class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0 font-weight-bold text-dark">Detalle de Ruta</h5>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm float-right"
              data-toggle="modal"
              data-target="#modal_indicaciones_ruta_tep"
            >
              <i class="fas fa-map-marked-alt mr-1"></i> Indicaciones
            </button>
          </div>
        </div>
        <div class="card-body p-0" v-if="accion_ruta">
          <TepRutaTramo
            ref="tepRutaTramo"
            :accionRuta="accion_ruta"
            :tramosIniciales="tramosRutaAsociados"
          />
        </div>
        <div class="card-body p-4" v-else>
          <div
            v-if="tramosRutaAsociados.length === 0"
            class="alert alert-light border text-center mb-0"
          >
            <i class="fas fa-info-circle text-info fa-lg mb-2"></i>
            <p class="mb-0 font-weight-medium">
              Esta ruta no tiene tramos asociados.
            </p>
          </div>
          <ul v-else class="list-group list-group-flush">
            <li
              v-for="(tramo, idx) in tramosRutaAsociados"
              :key="'asoc-' + (tramo.id || idx)"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <span
                ><strong>{{ idx + 1 }}.</strong>
                {{ tramo.nombre || "Tramo " + (idx + 1) }}</span
              >
              <span class="badge badge-info"
                >{{ tramo.path ? tramo.path.length : 0 }} pts</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal_indicaciones_ruta_tep">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-geogo pt-2 pb-2">
            <h4 class="modal-title text-white">Indicaciones de Ruta</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <PanelIndicacionesRuta
              ref="PanelIndicacionesRuta"
            ></PanelIndicacionesRuta>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PanelIndicacionesRuta from "../../../../components/PanelIndicacionesRuta";
import TepRutaTramo from "./TepRutaTramo";

export default {
  name: "RutaDetalle",
  components: {
    PanelIndicacionesRuta,
    TepRutaTramo,
  },
  computed: {
    tramosAñadidosConPath() {
      if (!this.accion_ruta) {
        return this.tramosRutaAsociados.filter(
          (t) => t.path && t.path.length >= 2
        );
      }
      const child = this.$refs.tepRutaTramo;
      const tramosEdit =
        child && Array.isArray(child.tramosAñadidos)
          ? child.tramosAñadidos
          : [];
      return tramosEdit
        .map((tramo) => ({
          ...tramo,
          path: this.buildPathFromTramo(tramo),
        }))
        .filter((t) => t.path && t.path.length >= 2);
    },
  },
  data() {
    return {
      ruta: null,
      inicio_ruta: "image/iconos/inicio_ruta.png",
      fin_ruta: "image/iconos/fin_ruta.png",
      viewMap: {
        zoom: 12,
        center: { lat: 4.651371, lng: -74.071509 },
      },
      markers: {
        inicio_ruta: null,
        fin_ruta: null,
        ruta: { path: [] },
      },
      tramosRutaAsociados: [],
      accion_ruta: false,
      url_docs: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    cargarTramosAsociados() {
      if (!this.ruta || !this.ruta.id) {
        this.tramosRutaAsociados = [];
        return;
      }
      axios
        .get("/api/tep/rutas/tramos/" + this.ruta.id)
        .then((response) => {
          const rutaTramos =
            response.data && Array.isArray(response.data.ruta)
              ? response.data.ruta
              : [];
          this.tramosRutaAsociados = rutaTramos
            .map((rt) => {
              const tramo = rt.tramo_ruta || rt.tramoRuta || rt;
              const path = this.buildPathFromTramo(tramo);
              return {
                ...tramo,
                path,
              };
            })
            .filter((t) => t.path && t.path.length >= 2);
        })
        .catch(() => {
          this.tramosRutaAsociados = [];
        });
    },
    buildPathFromTramo(tramo) {
      const path = [];
      const det = tramo.det_tramos_rutas || tramo.detTramosRutas;
      if (det && Array.isArray(det) && det.length > 0) {
        det.forEach((d) => {
          if (d.orden == 1) {
            path.push({
              lat: parseFloat(d.lat_ini),
              lng: parseFloat(d.lon_ini),
            });
          }
          path.push({
            lat: parseFloat(d.lat_fin),
            lng: parseFloat(d.lon_fin),
          });
        });
      } else if (
        tramo.lat_origen != null &&
        tramo.lng_origen != null &&
        tramo.lat_destino != null &&
        tramo.lng_destino != null
      ) {
        path.push(
          {
            lat: parseFloat(tramo.lat_origen),
            lng: parseFloat(tramo.lng_origen),
          },
          {
            lat: parseFloat(tramo.lat_destino),
            lng: parseFloat(tramo.lng_destino),
          }
        );
      }
      return path;
    },
    getIndex() {
      this.ruta = this.$parent.form || null;
      if (!this.ruta || !this.ruta.id) return;
      this.getMarkersRuta();
      this.cargarRutaShow();
      this.cargarTramosAsociados();
    },
    cargarRutaShow() {
      axios
        .get("/api/tep/rutas/show/" + this.ruta.id)
        .then((response) => {
          const data = response.data;
          if (data && (data.lat_origen || data.ruta_polilineas)) {
            this.ruta = { ...this.ruta, ...data };
            this.getMarkersRuta();
          }
        })
        .catch(() => {});
    },
    getMarkersRuta() {
      this.markers.inicio_ruta = null;
      this.markers.fin_ruta = null;
      this.markers.ruta.path = [];
      if (!this.ruta) return;
      let latOrigen = null,
        lngOrigen = null,
        latDestino = null,
        lngDestino = null;
      if (this.ruta.lat_origen != null && this.ruta.lng_origen != null) {
        latOrigen = parseFloat(this.ruta.lat_origen);
        lngOrigen = parseFloat(this.ruta.lng_origen);
      }
      if (this.ruta.lat_destino != null && this.ruta.lng_destino != null) {
        latDestino = parseFloat(this.ruta.lat_destino);
        lngDestino = parseFloat(this.ruta.lng_destino);
      }
      if (this.ruta.ruta_polilineas && this.ruta.ruta_polilineas.length > 0) {
        const poly = this.ruta.ruta_polilineas;
        if (!latOrigen) {
          latOrigen = parseFloat(poly[0].lat_ini);
          lngOrigen = parseFloat(poly[0].lon_ini);
        }
        if (!latDestino) {
          const last = poly[poly.length - 1];
          latDestino = parseFloat(last.lat_fin);
          lngDestino = parseFloat(last.lon_fin);
        }
        poly.forEach((det) => {
          if (det.orden == 1) {
            this.markers.ruta.path.push({
              lat: parseFloat(det.lat_ini),
              lng: parseFloat(det.lon_ini),
            });
          }
          this.markers.ruta.path.push({
            lat: parseFloat(det.lat_fin),
            lng: parseFloat(det.lon_fin),
          });
        });
      }
      if (latOrigen != null && lngOrigen != null) {
        this.markers.inicio_ruta = {
          icon: this.inicio_ruta,
          position: { lat: latOrigen, lng: lngOrigen },
        };
      }
      if (latDestino != null && lngDestino != null) {
        this.markers.fin_ruta = {
          icon: this.fin_ruta,
          position: { lat: latDestino, lng: lngDestino },
        };
      }
      this.$nextTick(() => this.centrarMapa());
    },
    centrarMapa() {
      if (
        this.markers.inicio_ruta?.position &&
        this.markers.fin_ruta?.position
      ) {
        const lat =
          (this.markers.inicio_ruta.position.lat +
            this.markers.fin_ruta.position.lat) /
          2;
        const lng =
          (this.markers.inicio_ruta.position.lng +
            this.markers.fin_ruta.position.lng) /
          2;
        this.viewMap.center = { lat, lng };
      }
    },
  },
  watch: {
    accion_ruta(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.tepRutaTramo) {
            this.$refs.tepRutaTramo.tramosAñadidos =
              this.tramosRutaAsociados.map((t) =>
                JSON.parse(JSON.stringify(t))
              );
            this.$refs.tepRutaTramo.filtrarTramosCercanos();
          }
        });
      } /*  else {
        this.cargarTramosAsociados();
      } */
    },
  },
  mounted() {
    this.getIndex();
  },
};
</script>
